module.exports = __webpack_public_path__ + "static/media/card.e3aae737.svg";